<template>
  <div class="row">
    <div class="panel panel-default">
        <div class="panel-body">
          <form class="page-form form-horizontal" @submit.prevent="submit()">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9">
                <div class="form-group" :class="{ 'has-error': errors['institution_id'] }">
                  <institution-select id="institution_id" v-model="data.institution_id"  :institutions="this.institutions" :disabled="this.backusr.role != 'admin'"></institution-select>
                  <span class="help-block" v-for="(e,index) in errors['institution_id']" :key="index">{{e}}</span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="btn-group" role="group" >
                  <button type="submit" class="btn btn-success">Ingresar</button>
                  <button type="button" @click="limpiar" class="btn btn-info">Limpiar</button>
                </div>
              </div>
          </form>
        </div>
    </div>
  </div>
</template>

<script>
import InstitutionSelect from "./InstitutionSelect.vue";
import ElementUI from "element-ui";
import { Message } from "element-ui";

export default {
  data: function() {
    const institutions = _.cloneDeep(this.institutions);
    return {
      data: institutions,
      token: window.token.content,
      errors: {},
      dataSubmit: [],
    };
  },
  props: [
    "institutions",
    "authUserRole",
    "backusr"
  ],
  components: {
    InstitutionSelect
  },
  created() {
    if (this.backusr.role != 'admin'){
      this.data.institution_id = this.backusr.institution_id;
    }
  },
  methods: {
    submit: function() {
      let self        = this;
      self.dataSubmit = {};
      self.errors     = {};
      let errores     = {};
      let valido      = true;

      if ( typeof(self.data.institution_id) === "undefined" || self.data.institution_id === null || self.data.institution_id.trim() === "" ) {
          errores["institution_id"] = [ "Debe ingresar una institución valida." ];
          valido = false;
      }

      if (self.data.institution_id === "ZZ001" ) {
          errores["institution_id"] = [ "La institución ya se encuentra registrada." ];
          valido = false;
      }

      if (!valido) {
        self.errors = errores;
        return false;
      }

      if (self.data.institution_id) {
          self.dataSubmit = [self.data.institution_id];
        
          axios({
            url: "backend/channels/crearRegistro/",
            method: "POST",
            data: self.dataSubmit
          }).then(function(response) {
            if (response.data.result == 201) {
              errores["institution_id"] = [response.data.message];
              self.errors = errores;
            }else{
              window.location.replace(response.data.redirect);
            }
          }).catch(function(error) {
            console.log(error);
          });
      }
    },
    limpiar: function(){
      let self = this;
      self.data.institution_id = '';
      self.errors = {};
    },
  }  
};
</script>
<style>

</style>